import { Card, ListGroup } from "react-bootstrap";
import "./Menu.css";

const cocktails = [
  {
    name: "Aperol Spritz",
    ingredients: [
      { name: "Aperol", amount: "6 cl" },
      { name: "Prosecco", amount: "9 cl" },
      { name: "Soda", amount: "" },
    ],
  },
  {
    name: "ABC",
    ingredients: [
      { name: "Amaretto", amount: "2 cl" },
      { name: "Bananensaft", amount: "2 cl" },
      { name: "Blue Curacao", amount: "2 cl" },
      { name: "Zitronensaft", amount: "" },
    ],
  },
  {
    name: "Daiquiri",
    ingredients: [
      { name: "Rum", amount: "6 cl" },
      { name: "Limettensaft", amount: "" },
      { name: "Zuckersirup", amount: "" },
    ],
  },
  {
    name: "Cuba Libre",
    ingredients: [
      { name: "Rum", amount: "5 cl" },
      { name: "Cola", amount: "12 cl" },
      { name: "Limettensaft", amount: "" },
    ],
  },
  {
    name: "Cosmopolitan Orange",
    ingredients: [
      { name: "Wodka", amount: "4 cl" },
      { name: "Orangensaft", amount: "2 cl" },
      { name: "Limettensaft", amount: "" },
      { name: "Cointreau", amount: "2 cl" },
    ],
  },
  {
    name: "Moscow Mule",
    ingredients: [
      { name: "Wodka", amount: "5 cl" },
      { name: "Ginger Ale", amount: "10 cl" },
      { name: "Limettensaft", amount: "" },
    ],
  },
  {
    name: "Tequila Sunrise",
    ingredients: [
      { name: "Tequila", amount: "5 cl" },
      { name: "Orangensaft", amount: "10 cl" },
      { name: "Grenadine", amount: "" },
    ],
  },
  {
    name: "Margarita",
    ingredients: [
      { name: "Tequila", amount: "5 cl" },
      { name: "Limettensaft", amount: "" },
      { name: "Cointreau", amount: "2 cl" },
    ],
  },
  {
    name: "Caipirinha",
    ingredients: [
      { name: "Cachaça", amount: "4 cl" },
      { name: "Limettensaft", amount: "" },
      { name: "Rohrzucker", amount: "2 TL" },
      { name: "Ginger Ale", amount: "" },
    ],
  },
  {
    name: "Mai Tai",
    ingredients: [
      { name: "Weißer Rum", amount: "3 cl" },
      { name: "Brauner Rum", amount: "3 cl" },
      { name: "Cointreau", amount: "1 cl" },
      { name: "Mandelsirup", amount: "" },
      { name: "Limettensaft", amount: "" },
      { name: "Orangensaft", amount: "2 cl" },
      { name: "Ananassaft", amount: "2 cl" },
      { name: "Grenadine", amount: "" },
    ],
  },
];

export function CocktailMenu() {
  return (
    <Card className="mb-4 menu-card">
      <Card.Header as="h5">Cocktails</Card.Header>
      <ListGroup variant="flush">
        {cocktails.map((cocktail) => (
          <ListGroup.Item key={cocktail.name} className="menu-list-item">
            <strong>{cocktail.name}</strong>
            <p className="mb-0 text-muted">
              {cocktail.ingredients.map((ingredient, index) => (
                <span key={ingredient.name}>
                  {ingredient.name}
                  {ingredient.amount && (
                    <span className="ingredient-amount">
                      {" "}
                      ({ingredient.amount})
                    </span>
                  )}
                  {index < cocktail.ingredients.length - 1 && ", "}
                </span>
              ))}
            </p>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  );
}
